import React from 'react'

import { themeBasicColors, themeGradationColors } from '../../data/color';
import { useTheme } from '../../context/ThemeContext'
import styled from '@emotion/styled';

const ThemeSelector = () => {
  const { color, changeColor } = useTheme()

  return (
    <STheme>
      <button style={{
        padding: "13px 32px",
        background: color,
        fontFamily: "'M PLUS 1p', sans-serif",
        color: "#333",
        border: "none",
        boxShadow: "2px 8px 21px -2px #777777",
        borderRadius: "5px",
        margin: "10px",
      }}>
        背景色
      </button>

      <SThemeContent>
        <SThemeBackground>
          <SThemeSelector>
            <SThemeButtons>
              {
                themeBasicColors.map(color =>  (
                  <div
                    key={color}
                    onClick={()=> changeColor(color)}
                    style={{ background: color}}
                  >
                  </div>
                ))
              }
              {themeGradationColors.map(color => (
                <div
                  key={color}
                  onClick={() => changeColor(color)}
                  style={{ background: color }}
                />
              ))}
            </SThemeButtons>
          </SThemeSelector>
        </SThemeBackground>
      </SThemeContent>
    </STheme>
  )
}

const STheme = styled.div`
  margin-top:  30px;
`
const SThemeContent = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 2px 8px 21px -2px #777777;
`
const SThemeBackground = styled.div`
  display: flex;
`
const SThemeSelector = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 1200px;
  margin: 20px auto;
`
const SThemeButtons= styled.div`
  div {
    display: inline-block;
    width: 30px;
    height: 30px;
    cursor: pointer;
    margin: 0 6px;
    border-radius: 10%;
    box-shadow: 2px 8px 21px -2px #777777;
  }
`
export default ThemeSelector
